// @flow
import getters from './getters'
import mutations from './mutations'
import actions from './actions'
import type { InvoiceSummary } from '../../../types/invoice-summary'
import type { Module } from 'vuex'

export type InvoiceSpecificationsState = {
  invoiceSpecificationsForCurrentFilter: InvoiceSummary[],
  totalNoInvoiceSpecificationsForCurrentFilter: number,
  invoiceSpecificationsCurrentPageNumber: number,
  invoiceSpecificationsPageSize: number,
  invoiceSpecificationsOrderBy: ?string,
  invoiceSpecificationsOrderDirection: ?string,
  invoiceSpecificationsFilterInvoiceNumber: string,
  invoiceSpecificationsFilterInvoiceDate: string,
  invoiceSpecificationsFilterInvoiceYear: string,
  invoiceSpecificationsFilterInvoiceMonth: string
}
const initialState = (): InvoiceSpecificationsState => {
  return {
    invoiceSpecificationsForCurrentFilter: [],
    totalNoInvoiceSpecificationsForCurrentFilter: 0,
    invoiceSpecificationsCurrentPageNumber: 0,
    invoiceSpecificationsPageSize: 10,
    invoiceSpecificationsOrderBy: null,
    invoiceSpecificationsOrderDirection: null,
    invoiceSpecificationsFilterInvoiceNumber: '',
    invoiceSpecificationsFilterInvoiceDate: '',
    invoiceSpecificationsFilterInvoiceMonth: '',
    invoiceSpecificationsFilterInvoiceYear: ''
  }
}

export type InvoiceSpecificationsModule = Module<InvoiceSpecificationsState>

const invoiceSpecificationsModule: InvoiceSpecificationsModule = {
  namespaced: true,
  state: initialState(),
  initialState: initialState(),
  getters,
  mutations,
  actions
}

export default invoiceSpecificationsModule



// WEBPACK FOOTER //
// ./src/store/modules/invoice-specifications/index.js